<!-- Accessibility enabled template -->
<ng-container *ngIf="enableDataTableAccessibility$ | async; else oldTemplate">
<div *ngIf="form" [formGroup]="form" class="form-group select2-form-group">
  <div style="display: flex"
   [ngClass]="{
    'labelHidden':IsFromForm && (!label || (IsFormFieldNameHidden && !infoText)),
    'labelShow':IsFromForm && label && !IsFormFieldNameHidden && infoText && DisplayOnScreen
    }
  ">
    <span *ngIf="IsFromForm && IsInfoVisible && infoText && !DisplayOnScreen" class="ng-binding d-flex align-items-center">
      <i class="icon-info" role="img" [attr.aria-label]="infoText" [title]="infoText"></i>
    </span>
    <span *ngIf="!IsFromForm && infoText">
      <i class="icon-info" role="img" [attr.aria-label]="infoText" [title]="infoText"></i>
    </span>
    <div *ngIf="label">
      <ng-container *ngIf="!IsFormFieldNameHidden">
        <label [attr.for]="selectId" [ngClass]="IsFromForm ? 'field-title':''">{{ label }}</label>
        <span *ngIf="required || getErrorMessage() === error || control?.hasValidator(validator) || toShowRedAsteriskWhenDisabled && !(disabled || control.disabled || isHeader)" class="text-danger" aria-hidden="true">
          *
        </span>
      </ng-container>
      <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen">
        <br *ngIf="!IsFormFieldNameHidden">
        <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon"
          tabindex="0"
          role="button"
          [attr.aria-label]="isTextVisible ? 'Hide information' : 'Show information'"
          [attr.aria-expanded]="isTextVisible"
          title="Toggle Text" *ngIf="AllowMinimize"(click)="toggleText()" (keydown)="handleToggleKeydown($event)"></i>
          <span [class.hidden-text]="!isTextVisible" class="info-text">
            {{ infoText }}
          </span>
      </span>
    </div>
    <div *ngIf="canClear" class="select2-remove" tabindex="0" role="button" aria-label="Remove selection" (click)="clearSelect()" (keydown)="handleClearKeydown($event)">
      <i class="icon-close ml-2" aria-hidden="true"></i> Remove
    </div>
  </div>
  <div class="select-box select-custom2 select-custom2-general ">
    <select2
      *ngIf="!isOptionLoading() && !multiple && !isHeader"
      class="js-select2 w-100 select2-selection__placeholder"
      [formControlName]="controlName"
      [data]="getOptions()"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      (update)="change($event)"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
      [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
      [attr.aria-invalid]="control.dirty && control.errors"
      [attr.aria-required]="(control?.hasValidator(validator) || required) ? 'true' : null"
      (open)="selectOpened.emit()"
      (close)="selectClosed.emit()"
    >
    </select2>
    <select2
      *ngIf="!isOptionLoading() && !multiple && isHeader"
      class="js-select2 w-100 select2-selection__placeholder"
      [data]="getOptions()"
      [value]="control.value ? control.value : isFormAction ? '' : null"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
    <select2
      *ngIf="isOptionLoading() && !multiple"
      class="js-select2 w-100 select2-selection__placeholder"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
      [attr.aria-busy]="true"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
    <select2
      *ngIf="!isOptionLoading() && multiple && !fromAction"
      class="js-select2 w-100 select2-selection__placeholder"
      [multiple]="multiple"
      [formControlName]="controlName"
      [data]="getOptions()"
      [value]="value"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      (update)="change($event)"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
      [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
      [attr.aria-invalid]="control.dirty && control.errors"
      [attr.aria-required]="(control?.hasValidator(validator) || required) ? 'true' : null"
    >
    </select2>
    <select2
      *ngIf="!isOptionLoading() && multiple && fromAction && !isHeader"
      class="js-select2 w-100 select2-selection__placeholder"
      [multiple]="multiple"
      [formControlName]="controlName"
      [data]="getOptions()"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      (update)="change($event)"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
      [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
      [attr.aria-invalid]="control.dirty && control.errors"
      [attr.aria-required]="(control?.hasValidator(validator) || required) ? 'true' : null"
    >
    </select2>
    <select2
      *ngIf="!isOptionLoading() && multiple && fromAction && isHeader"
      class="js-select2 w-100 select2-selection__placeholder select-custom-disabled"
      [multiple]="multiple"
      [data]="getOptions()"
      [value]="control.value ? control.value : isFormAction ? '' : null"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
    <select2
      *ngIf="isOptionLoading() && multiple"
      class="js-select2 w-100 select2-selection__placeholder select-custom-disabled"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
      [attr.aria-busy]="true"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
  </div>
  <div *ngIf="control.dirty && control.errors && control.touched" class="info-box error-box" [attr.id]="errorId" role="alert" aria-live="polite">
    <span class="text-message">  {{ error }} </span>
  </div>
  <app-sr-only>
    <div aria-live="polite" aria-atomic="true">
      <span *ngIf="isOptionLoading()">Loading options, please wait</span>
    </div>
  </app-sr-only>
</div>

<div *ngIf="!form" class="form-group select2-form-group">
  <div style="display: flex">
    <span
      *ngIf="infoText != null && infoText != ''"
      class="ng-binding d-flex align-items-center"
    >
      <i class="icon-info" [title]="infoText"></i>
    </span>
    <label *ngIf="label && !IsFormFieldNameHidden" [attr.for]="selectId">{{ label }}</label>
  </div>
  <div class="select-box select-custom2 select-custom2-general">
    <select2
      *ngIf="!isOptionLoading()"
      class="js-select2 w-100 select2-selection__placeholder"
      [multiple]="multiple"
      [data]="getOptions()"
      [value]="selectedValue"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      (update)="change($event)"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
    >
    </select2>
    <select2
      *ngIf="isOptionLoading()"
      class="js-select2 w-100 select2-selection__placeholder"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [attr.id]="selectId"
      [attr.aria-label]="(control?.hasValidator(validator) || required) ? (accessibleLabel || label || 'Select option') + ', required' : (accessibleLabel || label || 'Select option')"
      [attr.aria-busy]="true"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
  </div>
</div>
</ng-container>

<!-- Original template (flag OFF) -->
<ng-template #oldTemplate>
<div *ngIf="form" [formGroup]="form" class="form-group select2-form-group">
  <div style="display: flex"
   [ngClass]="{
    'labelHidden':IsFromForm && (!label || (IsFormFieldNameHidden && !infoText)),
    'labelShow':IsFromForm && label && !IsFormFieldNameHidden && infoText && DisplayOnScreen
    }
  ">
    <span *ngIf="IsFromForm && IsInfoVisible && infoText && !DisplayOnScreen" class="ng-binding d-flex align-items-center">
      <i class="icon-info" role="img" [attr.aria-label]="infoText" [title]="infoText"></i>
    </span>
    <span *ngIf="!IsFromForm && infoText">
      <i class="icon-info" role="img" [attr.aria-label]="infoText" [title]="infoText"></i>
    </span>
    <div *ngIf="label">
      <ng-container *ngIf="!IsFormFieldNameHidden">
        <label [ngClass]="IsFromForm ? 'field-title':''">{{ label }}</label>
        <span *ngIf="required || getErrorMessage() === error || control?.hasValidator(validator) || toShowRedAsteriskWhenDisabled && !(disabled || control.disabled || isHeader)" class="text-danger" aria-hidden="true">
          *
        </span>
      </ng-container>
      <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen">
        <br *ngIf="!IsFormFieldNameHidden">
        <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon"
          tabindex="0"
          role="button"
          [attr.aria-label]="isTextVisible ? 'Hide information' : 'Show information'"
          [attr.aria-expanded]="isTextVisible"
          title="Toggle Text" *ngIf="AllowMinimize"(click)="toggleText()" (keydown)="handleToggleKeydown($event)"></i>
          <span [class.hidden-text]="!isTextVisible" class="info-text">
            {{ infoText }}
          </span>
      </span>
    </div>
    <div *ngIf="canClear" class="select2-remove" tabindex="0" role="button" aria-label="Remove selection" (click)="clearSelect()" (keydown)="handleClearKeydown($event)">
      <i class="icon-close ml-2" aria-hidden="true"></i> Remove
    </div>
  </div>
  <div class="select-box select-custom2 select-custom2-general ">
    <select2
      *ngIf="!isOptionLoading() && !multiple && !isHeader"
      class="js-select2 w-100 select2-selection__placeholder"
      [formControlName]="controlName"
      [data]="getOptions()"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      (update)="change($event)"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
      [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
      [attr.aria-invalid]="control.dirty && control.errors"
      [attr.aria-required]="required"
      (open)="selectOpened.emit()"
      (close)="selectClosed.emit()"
    >
    </select2>
    <select2
      *ngIf="!isOptionLoading() && !multiple && isHeader"
      class="js-select2 w-100 select2-selection__placeholder"
      [data]="getOptions()"
      [value]="control.value ? control.value : isFormAction ? '' : null"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
    <select2
      *ngIf="isOptionLoading() && !multiple"
      class="js-select2 w-100 select2-selection__placeholder"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
      [attr.aria-busy]="true"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
    <select2
      *ngIf="!isOptionLoading() && multiple && !fromAction"
      class="js-select2 w-100 select2-selection__placeholder"
      [multiple]="multiple"
      [formControlName]="controlName"
      [data]="getOptions()"
      [value]="value"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      (update)="change($event)"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
      [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
      [attr.aria-invalid]="control.dirty && control.errors"
      [attr.aria-required]="required"
    >
    </select2>
    <select2
      *ngIf="!isOptionLoading() && multiple && fromAction && !isHeader"
      class="js-select2 w-100 select2-selection__placeholder"
      [multiple]="multiple"
      [formControlName]="controlName"
      [data]="getOptions()"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      (update)="change($event)"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
      [attr.aria-describedby]="(control.dirty && control.errors && control.touched) ? errorId : null"
      [attr.aria-invalid]="control.dirty && control.errors"
      [attr.aria-required]="required"
    >
    </select2>
    <select2
      *ngIf="!isOptionLoading() && multiple && fromAction && isHeader"
      class="js-select2 w-100 select2-selection__placeholder select-custom-disabled"
      [multiple]="multiple"
      [data]="getOptions()"
      [value]="control.value ? control.value : isFormAction ? '' : null"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        input: disabled === true
      }"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
    <select2
      *ngIf="isOptionLoading() && multiple"
      class="js-select2 w-100 select2-selection__placeholder select-custom-disabled"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
      [attr.aria-busy]="true"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
  </div>
  <div *ngIf="control.dirty && control.errors && control.touched" class="info-box error-box" [attr.id]="errorId" role="alert" aria-live="polite">
    <span class="text-message">  {{ error }} </span>
  </div>
  <app-sr-only>
    <div aria-live="polite" aria-atomic="true">
      <span *ngIf="isOptionLoading()">Loading options, please wait</span>
    </div>
  </app-sr-only>
</div>

<div *ngIf="!form" class="form-group select2-form-group">
  <div style="display: flex">
    <span
      *ngIf="infoText != null && infoText != ''"
      class="ng-binding d-flex align-items-center"
    >
      <i class="icon-info" [title]="infoText"></i>
    </span>
    <label *ngIf="label && !IsFormFieldNameHidden" [attr.for]="selectId">{{ label }}</label>
  </div>
  <div class="select-box select-custom2 select-custom2-general">
    <select2
      *ngIf="!isOptionLoading()"
      class="js-select2 w-100 select2-selection__placeholder"
      [multiple]="multiple"
      [data]="getOptions()"
      [value]="selectedValue"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      (update)="change($event)"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
    >
    </select2>
    <select2
      *ngIf="isOptionLoading()"
      class="js-select2 w-100 select2-selection__placeholder"
      [displaySearchStatus]="'always'"
      [placeholder]="getPlaceholder()"
      [attr.id]="selectId"
      [attr.aria-label]="accessibleLabel"
      [attr.aria-busy]="true"
      [attr.aria-disabled]="true"
      disabled
    >
    </select2>
  </div>
</div>
</ng-template>
